<template>
  <div class="discipline" v-if="this.items.length > 1 ">
    <span>Disciplines</span>
    <select @change="$emit('change', $event)">
      <option value="0">-- Toutes --</option>
      <option v-for="item in items" :key="item.id" :value="item.id" :title="item.nameFr+' ['+item.id+']'">{{ item.nameFr }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersEventDiscipline',
  computed: {
    items () {
      const filter = this.$store.getters['Sport/Discipline/filtered']
      return this.$store.getters['Sport/Discipline/list'].filter(item => filter.indexOf(item.id) > -1)
    }
  }
}
</script>

<style scoped>
  .discipline{
    display:flex;
    align-items:center;
    margin-bottom:10px
  }
  .discipline > span{
    font-size:14px
  }
  .discipline > select{
    height:18px;
    margin-left:5px
  }
</style>
